// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AuthActions } from '../duck';
import { actions as AuthModalsActions } from '../auth-modals/duck';
import Auth from '../components/Auth';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    isAuthing: state.auth.isAuthing,
    authError: state.auth.authError,
    isRegistering: state.auth.isRegistering,
    signUpError: state.auth.signUpError,
    registerSuccessState: state.auth.registerSuccessState,
    verificationSuccess: state.authModals.verificationSuccess,
    locale: state.locale,
    sendForgotPasswordError: state.authModals.sendForgotPasswordError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...AuthActions, ...AuthModalsActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Auth);



// WEBPACK FOOTER //
// ./src/modules/auth/containers/AuthContainer.js